<template>
  <section class="d-flex">
    <div class="testimonial-section d-flex flex-column">
      <EditableField
        class="heading text"
        name="text"
        :editable="editable"
        v-model="localSection.heading"
        @editable_field:save="updateHeading"
        >{{ localSection.heading }}</EditableField
      >

      <EditableField
        :style="{ 'border-left': `8px solid ${accentColor}` }"
        name="text"
        :editable="editable"
        v-model="localSection.text"
        class="text"
        placeholder="Write the testimonial here"
        @editable_field:save="updateText"
      />

      <div class="attribution d-flex flex-column">
        <EditableField
          name="attribution_name"
          :editable="editable"
          v-model="localSection.attribution_name"
          class="attribution_name"
          placeholder="Write the name here"
          @editable_field:save="updateName"
        />
        <EditableField
          name="attribution_role"
          :editable="editable"
          v-model="localSection.attribution_role"
          class="attribution_role"
          placeholder="Write the role here"
          @editable_field:save="updateRole"
        />
      </div>
    </div>

    <div class="d-flex align-items-center ml-1">
      <SectionControls
        :recipient-id="recipientId"
        :case-study-id="caseStudyId"
        :index="index"
        v-if="editable"
      />
    </div>
  </section>
</template>
<script>
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'
import EditableField from '@app/components/EditableField.vue'

export default {
  name: 'TestimonialSection',
  components: { SectionControls, EditableField },
  mixins: [SectionMixin],
  props: {
    recipientId: { type: Number, required: true },
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    index: { type: Number, required: true },
    accentColor: { type: String, required: true },
    editable: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      localSection: { ...this.section },
    }
  },
  watch: {
    section: {
      handler(newSection) {
        this.localSection = { ...newSection }
      },
      deep: true,
    },
  },
  computed: {
    editableText() {
      // In Vue 3 you have to use null/undefined to make an attribute conditionally
      // not render, false won't work
      return this.editable ? true : null
    },
  },
  methods: {
    move(forward) {
      this.$emit('move-section', { index: this.index, forward })
    },
    updateHeading(newContent) {
      this.updateByField('heading')(newContent)
    },
    updateText(newContent) {
      this.updateByField('text')(newContent)
    },
    updateName(newContent) {
      this.updateByField('attribution_name')(newContent)
    },
    updateRole(newContent) {
      this.updateByField('attribution_role')(newContent)
    },
  },
}
</script>

<style lang="sass" scoped>
.delete
  cursor: pointer

.testimonial-section
  width: 100%
  gap: 8px
  .text
    padding-left: 4px
    padding-right: 4px
    font-size: 22px

  .attribution
    font-size: 16px
    &_name, &_role
      padding: 0 4px

  .heading
    font-size: 24px
    font-weight: bold
</style>
